// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import logo from '../../img/logo.svg';

type Props = {
  isLoading: boolean,
  message?: ?string,
}

type State = {}

class Loader extends React.Component<Props, State> {
  static defaultProps = {
    message: null,
  };
  state = {};

  render() {
    if (!this.props.isLoading) {
      return false;
    }
    return (
      <div className="loading-dots">
        <img className="logo" src={logo} alt="logo" />
        <div>
          <div className="loading-dots--dot" />
          <div className="loading-dots--dot" />
          <div className="loading-dots--dot" />
        </div>
        {
          this.props.message &&
          <div className="message">
            {this.props.message}
          </div>
        }
      </div>
    );
  }
}

export default withRouter(Loader);
